import Image from "next/image";
import { useEffect, useState } from "react"

export const FallBackImage = ({ src, layout = 'responsive', objectFit = 'cover', ...rest }) => {
    const [imgSrc, setImgSrc] = useState(src);
    useEffect(() => { setImgSrc(src); }, [src]);

    return (
        <Image
            {...rest}
            layout={layout}
            objectFit={objectFit}
            src={imgSrc ? imgSrc : '/img/no-image.jpeg'}
            onError={() => { setImgSrc('/img/no-image.jpeg') }} />
    )
}